import { render, staticRenderFns } from "./detailServices.vue?vue&type=template&id=21a17f40&scoped=true&"
import script from "./detailServices.vue?vue&type=script&lang=js&"
export * from "./detailServices.vue?vue&type=script&lang=js&"
import style0 from "./detailServices.vue?vue&type=style&index=0&id=21a17f40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a17f40",
  null
  
)

export default component.exports